import { render, staticRenderFns } from "./PostureDietList.vue?vue&type=template&id=10521bab&scoped=true&"
import script from "./PostureDietList.vue?vue&type=script&lang=js&"
export * from "./PostureDietList.vue?vue&type=script&lang=js&"
import style0 from "./PostureDietList.vue?vue&type=style&index=0&id=10521bab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10521bab",
  null
  
)

export default component.exports